import Vue from 'vue'

export default {
  SET_LOADING(state, loading) {
    Vue.set(state, 'loading', loading)
  },
  SET_MINHAS_UNIDADES(state, unidades) {
    Vue.set(state, 'minhasUnidades', unidades)
  },
  ADD_TODAS_UNIDADES(state, unidades) {
    Vue.set(state, 'todasUnidades', [...unidades])
  },
  CLEAR_ALL(state) {
    Vue.set(state, 'minhasUnidades', [])
    Vue.set(state, 'todasUnidades', [])
  },
}
